"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Database, Server, ChevronRight, ArrowLeft, Book, Info } from "lucide-react";

const DocsSidebar = () => {
    const pathname = usePathname();

    const links = [
        {
            title: "About",
            href: "/docs/about",
            icon: Info,
        },
        {
            title: "Database",
            href: "/docs",
            icon: Database,
        },
        {
            title: "Backend",
            href: "/docs/backend",
            icon: Server,
        },
    ];

    return (
        <div className="w-72 border-r border-border h-full flex flex-col bg-surface/50 backdrop-blur-xl">
            {/* Sidebar Header */}
            <div className="p-6 border-b border-border">
                <Link href="/" className="flex items-center gap-2 text-secondary-text hover:text-primary-text transition-colors mb-6 text-sm font-medium">
                    <ArrowLeft className="w-4 h-4" />
                    Back to Home
                </Link>
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center shadow-lg shadow-primary/20">
                        <Book className="w-4 h-4 text-white" />
                    </div>
                    <span className="font-bold text-lg text-primary-text tracking-tight">Docs</span>
                </div>
            </div>

            {/* Navigation */}
            <div className="flex-1 overflow-y-auto p-4">
                <div className="mb-2 px-3 text-xs font-semibold text-secondary-text/60 uppercase tracking-wider">
                    Guides
                </div>
                <nav className="space-y-1">
                    {links.map((link) => {
                        const isActive = pathname === link.href;

                        return (
                            <Link
                                key={link.href}
                                href={link.href}
                                className={`group flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${isActive
                                        ? "bg-primary/10 text-primary"
                                        : "text-secondary-text hover:bg-surface hover:text-primary-text"
                                    }`}
                            >
                                <div className="flex items-center gap-3">
                                    <link.icon className={`w-4 h-4 ${isActive ? "text-primary" : "text-secondary-text group-hover:text-primary-text"}`} />
                                    {link.title}
                                </div>
                                {isActive && <ChevronRight className="w-4 h-4 opacity-100" />}
                            </Link>
                        );
                    })}
                </nav>
            </div>

            {/* Sidebar Footer */}
            <div className="p-4 border-t border-border">
                <div className="bg-surface border border-border rounded-xl p-4">
                    <h5 className="text-sm font-semibold text-primary-text mb-1">Need Help?</h5>
                    <p className="text-xs text-secondary-text mb-3">
                        Can&apos;t find what you&apos;re looking for?
                    </p>
                    <button className="w-full py-2 px-3 bg-primary text-white text-xs font-bold rounded-lg hover:bg-primary/90 transition-colors">
                        Contact Support
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DocsSidebar;
